<template>
  <article class="base-modal">
    <section class="modal-popup" :class="commonStore.dialog?.type">
      <div class="icon">
        <svg
          v-if="commonStore.dialog?.type === 'alert'"
          xmlns="http://www.w3.org/2000/svg"
          width="46.2"
          height="39.95"
          viewBox="0 0 46.2 39.95"
        >
          <path
            id="warning_FILL0_wght700_GRAD0_opsz48"
            d="M.9,42.65,24,2.7,47.1,42.65Zm7.25-4.2h31.7L24,11.05Zm16.05-2.4a1.6,1.6,0,0,0,1.2-.525,1.664,1.664,0,0,0,.5-1.175,1.521,1.521,0,0,0-.525-1.175A1.708,1.708,0,0,0,24.2,32.7a1.637,1.637,0,0,0-1.2.5,1.581,1.581,0,0,0-.5,1.15,1.6,1.6,0,0,0,.525,1.2,1.664,1.664,0,0,0,1.175.5ZM22.7,30.6h3V19.8h-3ZM24,24.75Z"
            transform="translate(-0.9 -2.7)"
            fill="red"
          />
        </svg>
        <svg
          v-else-if="commonStore.dialog?.type === 'confirm'"
          xmlns="http://www.w3.org/2000/svg"
          width="35.734"
          height="35.734"
          viewBox="0 0 35.734 35.734"
        >
          <g id="그룹_633" data-name="그룹 633" transform="translate(-653 -268)">
            <path
              id="info_FILL0_wght700_GRAD0_opsz48"
              d="M20.6,38.434a17.552,17.552,0,0,1-6.949-1.386,17.831,17.831,0,0,1-9.511-9.49,17.506,17.506,0,0,1-1.386-6.97A17.683,17.683,0,0,1,7.957,7.928a18.393,18.393,0,0,1,5.669-3.821A17.28,17.28,0,0,1,20.6,2.7a17.43,17.43,0,0,1,6.991,1.407,17.887,17.887,0,0,1,9.49,9.49,17.43,17.43,0,0,1,1.407,6.991,17.281,17.281,0,0,1-1.407,6.97,17.943,17.943,0,0,1-9.49,9.469A17.43,17.43,0,0,1,20.6,38.434Zm.042-3.947a13.356,13.356,0,0,0,9.8-4.052,13.454,13.454,0,0,0,4.052-9.889,13.356,13.356,0,0,0-4.052-9.8A13.4,13.4,0,0,0,20.6,6.689a13.4,13.4,0,0,0-9.847,4.052A13.4,13.4,0,0,0,6.7,20.588a13.4,13.4,0,0,0,4.052,9.847A13.454,13.454,0,0,0,20.638,34.487ZM20.6,20.588Z"
              transform="translate(650.25 265.3)"
              fill="#0e566c"
            />
            <path
              id="question-solid"
              d="M3.85,34.567A1.282,1.282,0,0,0,2.567,35.85,1.283,1.283,0,0,1,0,35.85,3.851,3.851,0,0,1,3.85,32H7.74a5.094,5.094,0,0,1,1.845,9.842l-2.527.983v.726a1.283,1.283,0,0,1-2.567,0v-.726a2.561,2.561,0,0,1,1.636-2.39l2.527-.983a2.528,2.528,0,0,0-.914-4.885Zm1.925,15.4a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,5.775,49.968Z"
              transform="translate(664 245)"
              fill="#0e566c"
            />
          </g>
        </svg>
        <svg
          v-else-if="commonStore.dialog?.type === 'info'"
          xmlns="http://www.w3.org/2000/svg"
          width="35.734"
          height="35.734"
          viewBox="0 0 35.734 35.734"
        >
          <path
            id="info_FILL0_wght700_GRAD0_opsz48"
            d="M19,29.448h3.443V18.908H19Zm1.6-13.017a1.962,1.962,0,0,0,1.449-.567,1.91,1.91,0,0,0,.567-1.407,2.017,2.017,0,1,0-4.031-.042,1.925,1.925,0,0,0,.588,1.449A1.981,1.981,0,0,0,20.6,16.431Zm0,22a17.552,17.552,0,0,1-6.949-1.386,17.831,17.831,0,0,1-9.511-9.49,17.506,17.506,0,0,1-1.386-6.97A17.683,17.683,0,0,1,7.957,7.928a18.393,18.393,0,0,1,5.669-3.821A17.28,17.28,0,0,1,20.6,2.7a17.43,17.43,0,0,1,6.991,1.407,17.887,17.887,0,0,1,9.49,9.49,17.43,17.43,0,0,1,1.407,6.991,17.281,17.281,0,0,1-1.407,6.97,17.943,17.943,0,0,1-9.49,9.469A17.43,17.43,0,0,1,20.6,38.434Zm.042-3.947a13.356,13.356,0,0,0,9.8-4.052,13.454,13.454,0,0,0,4.052-9.889,13.356,13.356,0,0,0-4.052-9.8A13.4,13.4,0,0,0,20.6,6.689a13.4,13.4,0,0,0-9.847,4.052A13.4,13.4,0,0,0,6.7,20.588a13.4,13.4,0,0,0,4.052,9.847A13.454,13.454,0,0,0,20.638,34.487ZM20.6,20.588Z"
            transform="translate(-2.75 -2.7)"
            fill="#1e561f"
          />
        </svg>
        <p v-if="commonStore.dialog?.title" class="title">
          <span>{{ commonStore.dialog?.title }}</span>
        </p>
      </div>
      <div class="message">
        <span v-html="commonStore.dialog?.message"></span>
      </div>
      <div class="button">
        <BaseButton
          v-if="commonStore.dialog?.type === 'alert' || commonStore.dialog?.type === 'info'"
          class="outline"
          :theme="commonStore.dialog?.type"
          :count="commonStore.dialog.autoCloseSeconds"
          @button-click="handleConfirmClick"
        >
          {{ t('button.confirm') }}
        </BaseButton>
        <BaseButtonGroup v-else-if="commonStore.dialog?.type === 'confirm'">
          <BaseButton class="outline" :theme="commonStore.dialog?.type" @button-click="handleConfirmClick">
            {{ t('button.yes') }}
          </BaseButton>
          <BaseButton
            class="outline"
            :theme="commonStore.dialog?.type"
            text-color="#0E566C"
            @button-click="handleCancelClick"
          >
            {{ t('button.no') }}
          </BaseButton>
        </BaseButtonGroup>
      </div>
    </section>
  </article>
</template>

<script setup lang="ts">
  import BaseButton from '@/components/base/BaseButton.vue';
  import BaseButtonGroup from '@/components/base/BaseButtonGroup.vue';
  import { useCommonStore } from '@/stores/common';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const commonStore = useCommonStore();

  const handleConfirmClick = () => commonStore.hideDialog(true);

  const handleCancelClick = () => commonStore.hideDialog(false);
</script>

<style scoped lang="scss">
  @use '@/assets/scss/variables' as vars;

  .base-modal {
    z-index: vars.$z-index-dialog;
  }

  .modal-popup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2.9851vw;
    border: 0.0746vw solid #73a259;
    border-radius: 0.2985vw;
    background-color: #fcfff5;
    padding: 1.4925vw;
    width: 44.7761vw;
    @media (max-width: vars.$md) {
      width: 80%;
    }
    span {
      color: #5f775f;
    }
    button {
      border-color: #1e561f;
    }
    &.alert {
      border-color: #ff0606;
      background-color: #fff6f6;
      span {
        color: #00000099;
      }
    }
    &.confirm {
      border-color: #347e95;
      background-color: #f4f7fc;
      span {
        color: #2c768d;
      }
    }

    .icon {
      width: 100%;
      margin-top: 2.0896vw;
      text-align: center;
      .title {
        margin-top: 0.7463vw;
        font-weight: bold;
        font-size: 1.9403vw;
        text-align: center;
        @media (max-width: vars.$md) {
          font-size: 18px;
        }
      }
    }

    .message span {
      white-space: pre-line;
      font-size: 1.6418vw;
      @media (max-width: vars.$md) {
        font-size: 14px;
      }
    }

    .button {
      width: 100%;
    }
  }
</style>
